/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Button, ButtonGroup, Surface, Text } from '@zapier/design-system';

import { getAppUrl } from 'app/developer-v3/utils/url/url';
import { useAvroEvent, useRouter } from 'app/developer-v3/hooks';

const styleRoot = css`
  display: flex;
  gap: 20px;
  padding: 30px;
  justify-content: center;

  > div {
    max-width: 604px;
  }
`;

type Props = {
  appId: number;
};

export default function PendingCongrats({ appId }: Props) {
  const { routeTo } = useRouter();
  const { emitPartnerUserInteractionEvent } = useAvroEvent();
  const appUrl = getAppUrl(appId);

  function handleShowMyIntegrationClick(
    event: React.MouseEvent<HTMLButtonElement>
  ) {
    event.preventDefault();

    emitPartnerUserInteractionEvent({
      eventAction: 'click',
      interactionGoal: 'Navigate user to Showcase my integration',
      interactionName: 'showcase_my_integration_button_clicked',
    });

    window.open(
      'https://zapier.com/blog/guide-showcase-integration-customer-journey/',
      '_blank'
    );
  }

  function handleExploreEmbeddingClick(
    event: React.MouseEvent<HTMLButtonElement>
  ) {
    event.preventDefault();

    emitPartnerUserInteractionEvent({
      eventAction: 'click',
      interactionGoal: 'Navigate user to Embed Zapier page',
      interactionName: 'explore_embedding_button_clicked',
    });

    routeTo(`${appUrl}/embed`);
  }

  return (
    <Surface backgroundColor="UiPrimaryWeakest">
      <div css={styleRoot}>
        <div>
          <Text tag="h3" textAlign="center" type="ParagraphHeader3">
            Congrats!
          </Text>
          <Text
            margin="20px 0px 30px 0px"
            tag="p"
            textAlign="center"
            type="Body1"
          >
            Your integration was successfully submitted! Our team is working to
            review it and will reach out. In the meantime, explore ways to
            showcase your integration to your users to improve user upgrades,
            retention, and lifetime value.
          </Text>
          <ButtonGroup columnSize="minmax(200px, max-content)" justify="center">
            <Button
              href="https://zapier.com/blog/guide-showcase-integration-customer-journey/"
              onClick={handleShowMyIntegrationClick}
              target="_blank"
            >
              Showcase my integration
            </Button>
            <Button
              color="secondary"
              href={`${appUrl}/embed`}
              onClick={handleExploreEmbeddingClick}
            >
              Explore embedding
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Surface>
  );
}
